{
  "areaCameraListPopover": {
    "title": "Cameras in {{areaName}}",
    "message": "No cameras"
  },
  "areaCreateDialog": {
    "required": "Enter an area name.",
    "max": "Area name must be 100 characters or fewer.",
    "test": "Phone number can contain only numbers and hyphens.",
    "test2": "Enter the postal code as 7 digits.",
    "enqueueSnackbar": "Area created",
    "enqueueSnackbar2": "The area couldn't be created.",
    "text": "Creating...",
    "text2": "Create",
    "title": "Create area",
    "label": "Area name",
    "label2": "Phone number",
    "label3": "Postal code",
    "label4": "Prefecture",
    "label5": "City",
    "label6": "Street address and building"
  },
  "areaDeleteDialog": {
    "enqueueSnackbar": "Area deleted",
    "enqueueSnackbar2": "The area couldn't be deleted.",
    "text": "Deleting...",
    "title": "Delete area",
    "text2": "」 will be deleted. Continue?",
    "text3": "This action can't be undone."
  },
  "areaEditDialog": {
    "required": "Enter an area name.",
    "max": "Area name must be 100 characters or fewer.",
    "matches": "Phone number can contain only numbers and hyphens.",
    "matches2": "Enter the postal code as 7 digits.",
    "test": "Clip storage capacity must be a number of 0 or greater.",
    "enqueueSnackbar": "Area updated",
    "enqueueSnackbar2": "The area couldn't be updated.",
    "text": "Loading...",
    "text2": "The area information wasn't found.",
    "title": "Edit area",
    "text3": "Updating...",
    "label": "Area name",
    "label2": "Phone number",
    "label3": "Postal code",
    "label4": "Prefecture",
    "label5": "City",
    "label6": "Street address and building",
    "label7": "Clip storage capacity (GB)"
  },
  "areaFilterBar": {
    "placeholder": "Search by area name",
    "button": "Create area"
  },
  "areaTable": {
    "label": "Area name",
    "text": "Cameras",
    "text2": "{{cameraCount}} cameras",
    "text3": "Users",
    "text4": "{{userCount}} users",
    "text5": "Map"
  },
  "areaTableHeader": {
    "text": " areas"
  },
  "areaUserListPopover": {
    "title": "Users in {{areaName}}",
    "message": "No users"
  },
  "area": {
    "title": "Area management"
  }
}
